import { render } from "./EmailOwnerTemplatePopUp.vue?vue&type=template&id=ccfc78f8&scoped=true"
import script from "./EmailOwnerTemplatePopUp.vue?vue&type=script&lang=js"
export * from "./EmailOwnerTemplatePopUp.vue?vue&type=script&lang=js"

import "./EmailOwnerTemplatePopUp.vue?vue&type=style&index=0&id=ccfc78f8&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccfc78f8"]])

export default __exports__